import { render, staticRenderFns } from "./DeleteSmtpSetting.vue?vue&type=template&id=11705ee5"
import script from "./DeleteSmtpSetting.vue?vue&type=script&lang=js"
export * from "./DeleteSmtpSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports